var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"building-edit-reports-tab"},[(_vm.can('buildings.edit'))?_c('a-row',[_c('a-col',{attrs:{"span":11}},[_c('label',[_vm._v("Meterkastlijst")]),_c('br'),_c('a-button',{attrs:{"loading":_vm.loading},on:{"click":_vm.downloadBuildingSpecification}},[_vm._v("Download")])],1)],1):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }